import React from 'react';
import { Clock, Trash } from 'lucide-react';
import { ProjectCardProps } from '../../types/project';

export const SoundworldProjectCard: React.FC<ProjectCardProps> = ({ project, onDelete, onContinue }) => {
    const formattedDate = new Date(project.created_at).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    return (
        <div className="border h-max border-border rounded-lg p-4 shadow-sm hover:shadow-md transition relative group bg-card">
            <div className="flex items-start justify-between">
                <div>
                    <h3 className="font-semibold text-sm text-card-foreground">{ project.name || 'Untitled Project' }</h3>
                    <p className="text-xs text-muted-foreground">{ project.description || "No description" }</p>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                    <button
                        onClick={ () => onDelete(project.project_id) }
                        className="hover:text-destructive"
                    >
                        <Trash size={ 14 } />
                    </button>
                </div>
            </div>
            <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center text-xs text-muted-foreground gap-1">
                    <Clock size={ 14 } />
                    { formattedDate }
                </div>
                <button
                    onClick={ () => onContinue(project.project_id) }
                    className="btn-primary text-xs px-3 py-1"
                >
                    Continue Editing
                </button>
            </div>
        </div>
    );
}; 